<template>
  <footer class="footer">
    <div class="footer__inner">
      <div class="footer__top">
        <div class="footer__left">
          <!-- 乌尔都语环境下：文字在前，logo在后 -->
          <template v-if="$i18n.locale === 'ur'">
            <span class="footer__brand">Innovative Pay</span>
            <img :src="logoSrc" alt="logo" class="footer__logo" />
          </template>
          <!-- 其他语言环境下：logo在前，文字在后 -->
          <template v-else>
            <img :src="logoSrc" alt="logo" class="footer__logo" />
            <span class="footer__brand">Innovative Pay</span>
          </template>
        </div>

        <div class="footer__right">
          <div class="subscribe">
            <input
              class="subscribe__input"
              type="email"
              :placeholder="$t('hero.emailPlaceholder')"
              aria-label="email"
            />
            <button class="subscribe__btn">{{ $t("hero.cta") }}</button>
          </div>
        </div>
      </div>

      <div class="footer__center">
        <span class="footer__info"
          >{{ $t("footer.telephone") }} : 03202926906</span
        >
        <span class="footer__info"
          >{{ $t("footer.customerServiceEmail") }}:
          jerry.wr@pkininnovative.com</span
        >
        <span class="footer__info">{{ $t("footer.copyright") }}</span>
      </div>
    </div>

    <button
      class="back-to-top"
      v-show="showBackToTop"
      @click="scrollTop"
      :aria-label="$t('footer.backToTop')"
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 15l6-6 6 6"
          stroke="#fff"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
  </footer>
</template>

<script>
import logoPng from "@/assets/img/homePage/logo.png"

export default {
  name: "footerBox",
  data() {
    return {
      showBackToTop: true,
      logoSrc: logoPng,
    }
  },
  mounted() {
    if (typeof document !== "undefined") {
      const root = document.documentElement
      root.style.minHeight = "500px"
      document.body.style.minHeight = "500px"
      const appEl = document.getElementById("app")
      if (appEl) appEl.style.minHeight = "500px"
    }
  },
  beforeDestroy() {
    if (typeof document !== "undefined") {
      const root = document.documentElement
      root.style.minHeight = ""
      document.body.style.minHeight = ""
      const appEl = document.getElementById("app")
      if (appEl) appEl.style.minHeight = ""
    }
  },
  methods: {
    scrollTop() {
      window.scrollTo({ top: 0, behavior: "smooth" })
    },
  },
}
</script>

<style scoped>
.footer {
  position: relative;
  background: #ffffff;
  min-height: 500px;
  padding: 154px 0;
}
.footer__inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.footer__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.footer__left {
  display: flex;
  align-items: center;
  gap: 10px;
}
.footer__logo {
  width: 40px;
  height: 40px;
}
.footer__brand {
  min-width: 166px;
  font-weight: 600;
  font-size: 29px;
  line-height: 1;
  color: #0b1120;
}
.footer__center {
  width: 100%;
  display: flex;
  justify-content: center;
  color: #475569;
  font-size: 16px;
}
.footer__info {
  white-space: nowrap;
  padding: 50px 36px;
}

.footer__right {
  display: flex;
  align-items: center;
}

.subscribe {
  display: flex;
  align-items: center;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 9999px;
  padding: 2px;
}
.subscribe__input {
  width: 240px;
  height: 36px;
  border: none;
  outline: none;
  padding: 0 12px 0 12px;
  font-size: 18px;
  color: #0f172a;
  background: transparent;
}
.subscribe__input::placeholder {
  color: #94a3b8;
}
.subscribe__btn {
  height: 36px;
  padding: 0 14px;
  border: none;
  border-radius: 9999px;
  background: linear-gradient(90deg, #4f46e5 0%, #2563eb 100%);
  color: #fff;
  font-weight: 600;
  font-size: 18px;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease,
    background-color 0.2s ease;
  box-shadow: 0 6px 16px rgba(37, 99, 235, 0.35);
}
.subscribe__btn:hover {
  transform: translateY(-1px);
  filter: brightness(1.05);
}

.back-to-top {
  position: fixed;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  width: 30px;
  height: 30px;
  border: none;
  border-radius: 8px;
  background: linear-gradient(180deg, #3b82f6 0%, #2563eb 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  cursor: pointer;
  box-shadow: 0 6px 16px rgba(59, 130, 246, 0.35);
}

@media (max-width: 992px) {
  .footer__inner {
    gap: 12px;
  }
  .footer__center {
    flex-wrap: wrap;
    gap: 12px 20px;
  }
  .subscribe__input {
    width: 200px;
  }
  .footer {
    min-height: auto;
    padding: 16px 0;
  }
  .footer__top {
    flex-direction: column;
    align-items: center;
    gap: 12px;
  }
  .footer__brand {
    min-width: auto;
    font-size: 18px;
  }
  .footer__right {
    width: 100%;
    justify-content: center;
  }
  .subscribe {
    width: 100%;
    max-width: 400px;
  }
  .subscribe__input {
    width: 100%;
    flex: 1 1 auto;
  }
  .footer__info {
    white-space: normal;
    padding: 4px 0;
  }
  .back-to-top {
    top: auto;
    bottom: 20px;
    transform: none;
  }
}

@media (max-width: 768px) {
  .footer__inner {
    padding: 0 12px;
    gap: 16px;
  }
  .footer__top {
    gap: 16px;
  }
  .footer__brand {
    font-size: 20px;
  }
  .footer__logo {
    width: 32px;
    height: 32px;
  }
  .subscribe {
    max-width: 100%;
    border-radius: 12px;
    padding: 3px;
  }
  .subscribe__input {
    height: 44px;
    font-size: 16px;
    padding: 0 16px;
  }
  .subscribe__btn {
    height: 44px;
    padding: 0 20px;
    font-size: 16px;
    white-space: nowrap;
  }
  .footer__center {
    flex-direction: column;
    align-items: center;
    gap: 8px;
    font-size: 14px;
  }
  .footer__info {
    text-align: center;
    padding: 8px 0;
  }
}

@media (max-width: 480px) {
  .footer__inner {
    padding: 0 8px;
    gap: 12px;
  }
  .footer__brand {
    font-size: 18px;
  }
  .footer__logo {
    width: 28px;
    height: 28px;
  }
  .footer__left {
    gap: 8px;
  }
  .subscribe {
    border-radius: 8px;
    padding: 2px;
  }
  .subscribe__input {
    height: 40px;
    font-size: 14px;
    padding: 0 12px;
  }
  .subscribe__btn {
    height: 40px;
    padding: 0 16px;
    font-size: 14px;
  }
  .footer__center {
    font-size: 12px;
    gap: 6px;
  }
  .footer__info {
    padding: 6px 0;
    line-height: 1.4;
  }
  .back-to-top {
    right: 12px;
    bottom: 12px;
    width: 28px;
    height: 28px;
  }
}

@media (max-width: 360px) {
  .footer__brand {
    font-size: 16px;
  }
  .footer__logo {
    width: 24px;
    height: 24px;
  }
  .subscribe__input {
    height: 36px;
    font-size: 13px;
    padding: 0 10px;
  }
  .subscribe__btn {
    height: 36px;
    padding: 0 12px;
    font-size: 13px;
  }
  .footer__center {
    font-size: 11px;
  }
}
</style>
